import SidebarBookingsPriceRoute from 'uplisting-frontend/pods/-sidebar/bookings/price/route';

export default class ProtectionOverviewBookingsPriceEditRoute extends SidebarBookingsPriceRoute {
  parentRoute = 'protection.overview.bookings';
}
